import { useState } from 'react';
import logo from '../assets/logo.png';
import resume from "../assets/resume.pdf";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faFileDownload } from '@fortawesome/free-solid-svg-icons';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'About', href: '#home' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Skills', href: '#skills' },
    { name: 'Certifications', href: '#certs' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur-md bg-dark-500/90 border-b border-zinc-800/80 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 flex justify-between items-center py-3 sm:py-4 text-white">
        {/* Brand */}
        <a href="#home" className="flex items-center gap-2.5 sm:gap-3 group shrink-0">
          <div className="relative">
            <img src={logo} className="w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-teal-500/40 group-hover:border-teal-400 transition-all shadow-md shadow-teal-500/10" alt="Syam logo" />
            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-emerald-500 border-2 border-dark-500 rounded-full"></span>
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-sm sm:text-base tracking-tight text-white group-hover:text-teal-400 transition-colors">Syam R S</span>
            <span className="text-[10px] sm:text-[11px] font-medium text-teal-400/90 tracking-wide uppercase hidden xs:inline sm:inline">Staff Cloud Architect</span>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="px-3.5 py-1.5 text-sm font-medium text-gray-300 hover:text-white hover:bg-zinc-800/60 rounded-md transition-all"
            >
              {link.name}
            </a>
          ))}
        </nav>

        {/* Action Button & Mobile Toggle */}
        <div className="flex items-center gap-2 sm:gap-3 shrink-0">
          <a
            href={resume}
            rel="noreferrer"
            target="_blank"
            className="inline-flex items-center gap-1.5 sm:gap-2 bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-400 hover:to-emerald-400 text-dark-900 font-semibold text-xs sm:text-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-lg shadow-teal-500/20 hover:shadow-teal-500/40 transition-all duration-200 transform hover:-translate-y-0.5"
          >
            <FontAwesomeIcon icon={faFileDownload} className="text-xs" />
            <span>Resume</span>
          </a>

          {/* Mobile hamburger toggle */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-300 hover:text-white hover:bg-zinc-800/80 transition-colors focus:outline-none"
            aria-label="Toggle menu"
          >
            <FontAwesomeIcon icon={isOpen ? faTimes : faBars} className="text-lg w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="lg:hidden border-t border-zinc-800 bg-dark-500/98 px-6 py-4 shadow-xl">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="px-4 py-2.5 text-sm font-medium text-gray-300 hover:text-teal-400 hover:bg-zinc-800/60 rounded-md transition-colors"
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
